import { createContext } from 'react';

const ApiDataContext = createContext<any>({});

export default ApiDataContext;
